import * as React from 'react';
const SvgRedo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="none"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 3.548c-.06-.002.06 0 0 0 .023-.002.227 0 .25 0h4.393L7.375 1.28A.75.75 0 0 1 8.436.22l3.353 3.353a.75.75 0 0 1 .212.638.75.75 0 0 1-.215.444L8.54 7.902a.75.75 0 0 1-1.06-1.06L9.27 5.047H5a3.5 3.5 0 1 0 0 7h4.25a.75.75 0 0 1 0 1.5H5a5 5 0 0 1 0-10"
    />
  </svg>
);
export default SvgRedo;
